// Privacyrechten (0036; docs/DESIGN.md §8.PR), handgeschreven zoals weather.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/privacy.ts). openapi.contract.test.ts bewaakt dat elke aanroep bestaat.
export function createPrivacyClient({ request }) {
    const id = (value) => encodeURIComponent(value);
    return {
        exports: {
            list: () => request('GET', '/v1/app/privacy/exports'),
            /** Owner, step-up; 202 met status pending (de ZIP wordt op de achtergrond gemaakt). */
            request: () => request('POST', '/v1/app/privacy/exports', {}),
            /** Pad voor een gewone download (één keer; de browser bewaart het bestand). */
            downloadUrl: (exportId) => `/v1/app/privacy/exports/${id(exportId)}/download`,
        },
        removals: {
            list: () => request('GET', '/v1/app/members/removals'),
            preview: (memberId) => request('GET', `/v1/app/members/${id(memberId)}/removal/preview`),
            /** Ouders, step-up; een andere ouder alleen door de owner. */
            remove: (memberId) => request('POST', `/v1/app/members/${id(memberId)}/removal`, {}),
            undo: (removalId) => request('POST', `/v1/app/members/removals/${id(removalId)}/undo`, {}),
        },
        consents: {
            /** Kinderen onder 16 met een login zonder toestemming (van vóór 0044); ouders. */
            loginsWithoutConsent: () => request('GET', '/v1/app/members/logins-without-consent'),
            get: (memberId) => request('GET', `/v1/app/members/${id(memberId)}/consents`),
            /** Ouders; het vinkje staat nooit vooraf aan (accepted: true alleen na een klik). */
            /** `locale`: de taal waarin de ouder de tekst las (nl, en, tr, ar, de of fr). */
            give: (memberId, purpose, textVersion, locale) => request('POST', `/v1/app/members/${id(memberId)}/consents`, {
                purpose,
                text_version: textVersion,
                locale,
                accepted: true,
            }),
            /**
             * Even makkelijk als geven: de login gaat meteen uit, de foto meteen weg. child_login zonder
             * toestemming (een login van vóór 0044): zet die login uit.
             */
            withdraw: (memberId, purpose) => request('POST', `/v1/app/members/${id(memberId)}/consents/${id(purpose)}/withdraw`, {}),
        },
        deletion: {
            get: () => request('GET', '/v1/app/privacy/deletion'),
            /** Owner, step-up, de naam van het gezinsbord als bevestiging. */
            schedule: (confirmName) => request('POST', '/v1/app/privacy/deletion', {
                confirm_name: confirmName,
            }),
            cancel: () => request('DELETE', '/v1/app/privacy/deletion'),
        },
    };
}
//# sourceMappingURL=privacy.js.map